<template>
    <div>
        <m-assembly-table ref='pageForm'
                        :formData='formData'
                        :columns='columns'
                        :data='tableData'
                        :tableButtons='tableButtons'
                        :loading='loading'
                        :currentPage='settings.currentPage'
                        :pageSize='settings.pageSize'
                        :total='settings.total'
                        :settings='settings'
        >
        </m-assembly-table>
    </div>
</template>
<script>
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import axios from 'axios';
import {getOuList} from './financialAccounting';
export default {
    name: 'reconciliantMaintenance',
    components: {
        mAssemblyTable,
    },
    data () {
        return {
            formData: {
            },
            columns: {
                columns: [
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: 'red'
                                    }
                                }, '* '),
                                h('span', this.$t('reconciliantMaintenance.t1'))
                            ])
                        },
                        title: this.$t('reconciliantMaintenance.t1'), // 对账员名称
                        key: 'accounterName',
                        minWidth: 100,
                        render: (h, params) => {
                            if (params.row.edit) {
                                return h('Input', {
                                    props: {
                                        size: 'small',
                                        value: params.row.accounterName
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            let val = event.target.value;
                                            params.row.accounterName = val;
                                            this.tableData[params.index] = params.row;
                                        }
                                    }
                                })
                            } else {
                                return h('span', params.row.accounterName);
                            }
                        }
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: 'red'
                                    }
                                }, '* '),
                                h('span', this.$t('reconciliantMaintenance.t2'))
                            ])
                        },
                        title: this.$t('reconciliantMaintenance.t2'), // 联系电话
                        key: 'phone',
                        minWidth: 100,
                        render: (h, params) => {
                            if (params.row.edit) {
                                return h('Input', {
                                    props: {
                                        size: 'small',
                                        value: params.row.phone
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            let val = event.target.value;
                                            // if (!/^1[3-9]\d{9}$/.test(val)) {
                                            //     this.$Modal.warning({
                                            //         content: this.$t('reconciliantMaintenance.t8')
                                            //     })
                                            //     val = '';
                                            // }
                                            event.target.value = val;
                                            params.row.phone = val;
                                            this.tableData[params.index] = params.row;
                                        }
                                    }
                                })
                            } else {
                                return h('span', params.row.phone);
                            }
                        }
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: 'red'
                                    }
                                }, '* '),
                                h('span', this.$t('reconciliantMaintenance.t3'))
                            ])
                        },
                        title: this.$t('reconciliantMaintenance.t3'), // 传真
                        key: 'fax',
                        minWidth: 100,
                        render: (h, params) => {
                            if (params.row.edit) {
                                return h('Input', {
                                    props: {
                                        size: 'small',
                                        value: params.row.fax
                                    },
                                    on: {
                                        'on-blur': (event) => {
                                            let val = event.target.value;
                                            // if (!/^(0\d{2,3}-)?\d{7,8}$/.test(val)) {
                                            //     this.$Modal.warning({
                                            //         content: this.$t('reconciliantMaintenance.t12')
                                            //     })
                                            //     val = '';
                                            // }
                                            event.target.value = val;
                                            params.row.fax = val;
                                            this.tableData[params.index] = params.row;
                                        }
                                    }
                                })
                            } else {
                                return h('span', params.row.fax);
                            }
                        }
                    },
                    {
                        renderHeader: (h) => {
                            return h('span', [
                                h('span', {
                                    style: {
                                        color: 'red'
                                    }
                                }, '* '),
                                h('span', this.$t('reconciliantMaintenance.t10'))
                            ])
                        },
                        title: this.$t('reconciliantMaintenance.t10'), // 买方
                        key: 'ouId',
                        minWidth: 100,
                        render: (h, params) => {
                            if (params.row.edit && !params.row.accounterId) {
                                let options = [];
                                this.orgList.forEach((item) => {
                                    options.push(
                                        h('Option', {
                                            props: {
                                                label: item.label,
                                                value: item.value
                                            }
                                        })
                                    );
                                });
                                return h('Select', {
                                    props: {
                                        size: 'small',
                                        value: params.row.ouId,
                                        placeholder: ''
                                    },
                                    on: {
                                        'on-change': (value) => {
                                            params.row.ouId = value;
                                            params.row.ouName = this.orgList.find((item) => item.value === value).label;
                                            this.tableData[params.index] = params.row;
                                        }
                                    }
                                }, options);
                            } else {
                                return h('span', params.row.ouName);
                            }
                        }
                    },
                    {
                        title: this.$t('reconciliantMaintenance.t4'), // 有效标识
                        key: 'validFlag',
                        align: 'center',
                        minWidth: 100,
                        render: (h, params) => {
                            return h('span', params.row.validFlag === 'Y' ? this.$t('invoiceMonitoring.t23') : this.$t('invoiceMonitoring.t24'));
                        }
                    },
                    {
                        title: this.$t('reconciliantMaintenance.t5'), // 操作
                        key: 'edit',
                        minWidth: 100,
                        align: 'center',
                        render: (h, params) => {
                            if (!params.row.edit) {
                                return h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        icon: 'edit'
                                    },
                                    on: {
                                        click: () => {
                                            params.row.edit = true;
                                            // this.tableData[params.index] = params.row;
                                            this.$set(this.tableData, params.index, params.row);
                                            this.btnUpdate();
                                        }
                                    }
                                })
                            } else {
                                if (!params.row.accounterId) {
                                    return h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            icon: 'close'
                                        },
                                        style: {
                                            color: 'red'
                                        },
                                        on: {
                                            click: () => {
                                                this.$Modal.confirm({
                                                    content: this.$t('reconciliantMaintenance.t14'),
                                                    onOk: () => {
                                                        this.tableData.splice(params.index, 1);
                                                        this.btnUpdate();
                                                    }
                                                })
                                            }
                                        }
                                    });
                                } else {
                                    return h('Button', {
                                        props: {
                                            size: 'small',
                                            type: 'default'
                                        },
                                        on: {
                                            click: () => {
                                                params.row.edit = false;
                                                this.tableData[params.index] = params.row;
                                                this.btnUpdate();
                                            }
                                        }
                                    }, this.$t('common.cancelBtn'));
                                }
                            }
                        }
                    },
                ]
            },
            tableData: [],
            tableButtons: {
                customButtons: [
                    {
                        label: this.$t('reconciliantMaintenance.t6'), // 创建对账员
                        type: 'primary',
                        icon: 'archive',
                        disabled: true,
                        size: 'small',
                        click: (button) => {
                            this.addLine();
                        }
                    },
                    {
                        label: this.$t('reconciliantMaintenance.t7'), // 保存
                        type: 'primary',
                        icon: 'archive',
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            this.handleSaveOrUpdate(button);
                        }
                    }
                ]
            },
            loading: false,
            settings: {
                needPager: false,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: false,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: null,
                submitLoading: false
            },
            orgList: []
        }
    },
    methods: {
        addLine () {
            // this.tableButtons.customButtons[0].disabled = true;
            // this.tableButtons.customButtons[1].disabled = false;
            this.tableData.push({
                accounterName: '',
                phone: '',
                fax: '',
                validFlag: 'Y',
                edit: true
            });
            this.btnUpdate();
        },
        handleSaveOrUpdate (button) {
            /* 必填字段 */
            let keys = ['accounterName', 'phone', 'fax', 'ouId'];
            let error = false;
            for (let obj of this.tableData) {
                let emptyArr = [];
                for (let i2 of keys) {
                    if (!obj[i2]) {
                        emptyArr.push(this.columns.columns.find((item) => item.key === i2).title);
                    };
                }
                if (emptyArr.length > 0) {
                    error = true;
                    this.$Modal.warning({
                        content: `${emptyArr.join() + this.$t('reconciliantMaintenance.t9')}`
                    })
                    break;
                }
            }
            if (!error) {
                this.$set(button, 'loading', true);
                this.addAccounter(button);
            }
        },
        btnUpdate () {
            let flag = this.tableData.filter((item) => item.edit).length === 0;
            let vals = [!flag, flag];
            this.tableButtons.customButtons.forEach((item, index) => {
                item.disabled = vals[index];
            });
        },
        onSearch () {
            this.loading = true;
            if (this.vendorCode) {
                axios.get('/gscint/hwVendorAccounter/queryList', {
                    params: {
                        vendorCode: this.vendorCode
                    }
                })
                .then((res) => {
                    this.loading = false;
                    let {datas} = res.data.data;
                    if (datas) {
                        this.tableData = datas;
                        this.btnUpdate();
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                });
            } else {
                this.showErrorTips();
            }
        },
        // accounterId
        addAccounter (button) {
            this.loading = true;
            let postData = this.tableData.find((item) => item.edit);
            axios.post(`/gscint/hwVendorAccounter/${postData.accounterId ? 'updateAccounter' : 'addAccounter'}`, {
                vendorCode: this.vendorCode,
                ...postData
            })
            .then((res) => {
                this.$set(button, 'loading', false);
                this.loading = false;
                let {code, msg} = res.data.data;
                if (code === '1') {
                    this.$Modal.success({
                        content: this.$t(`reconciliantMaintenance.${postData.accounterId ? 't13' : 't11'}`)
                    });
                    this.onSearch();
                } else {
                    this.$Modal.error({
                        content: msg
                    });
                }
            })
            .catch(() => {
                this.$set(button, 'loading', false);
                this.showErrorTips();
            });
        }
    },
    mounted() {
        this.onSearch();
        getOuList((data) => {
            data.forEach((item) => {
                item.value = Number(item.value); 
            });
            this.orgList = data;
        });
    },
}
</script>